<template>
  <a
    :class="$attrs.class ? $attrs.class : 'link'"
    :target="target"
    rel="noopener"
    :href="to"
  >
    <slot />
  </a>
</template>

<script lang="ts" setup>
interface Props {
  to: string;
  target?: string;
}

withDefaults(defineProps<Props>(), {
  target: '_blank',
});
</script>

<style scoped lang="scss"></style>
